
















































































import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { ContrattiCreateBody, ContrattiFilterParams, ContrattiPDFTypes, ContrattiReplaceBody, ContrattiReturned, RuoloUtente } from "operatn-api-client";
import axios from "axios";

import { ActionTypes, AlertType } from "@/store";
import ResourceManagerMixin from "@/mixins/ResourceManagerMixin";
import ContrattoHandlerMixin from "@/mixins/handlers/ContrattoHandlerMixin";

import { downloadBlob } from "@/utils";

import OperatnActionDialog from "@/components/gears/dialogs/OperatnActionDialog.vue";
import OperatnBaseResourceManager, { Column, Actions } from "@/components/gears/bases/OperatnBaseResourceManager.vue";
import OperatnContrattoChiudiForm from "@/components/gears/forms/contratto/OperatnContrattoChiudiForm.vue";
import OperatnContrattoForm from "@/components/gears/forms/contratto/OperatnContrattoForm.vue";
import OperatnDateInput from "@/components/gears/inputs/OperatnDateInput.vue";
import OperatnOspiteInput from "@/components/gears/inputs/OperatnOspiteInput.vue";

interface Tuple {
  id: number;
  dataInizio: Date;
  dataFine: Date;
  nome: string;
  cognome: string;
  codiceFiscale: string;
  tipoContratto: string;
  codiceFabbricato: string;
  unitaImmobiliare: string;
  numeroStanza: string;
  postiLetto: string;
  dataFirma: Date | null;
  dataChiusuraAnticipata: Date | null;
  reference: ContrattiReturned;
  idQuietanziante: number;
}

@Component({
  components: {
    OperatnActionDialog,
    OperatnBaseResourceManager,
    OperatnContrattoForm,
    OperatnContrattoChiudiForm,
    OperatnDateInput,
    OperatnOspiteInput,
  },
})
export default class ContrattiAttivi extends Mixins<ResourceManagerMixin<Tuple, ContrattiCreateBody, ContrattiReplaceBody, number> & ContrattoHandlerMixin>(
  ResourceManagerMixin,
  ContrattoHandlerMixin
) {
  /* PROPS */

  @Prop({ type: Boolean, default: false })
  isRoot!: boolean;

  /* DATA */

  private contratti: ContrattiReturned[] = [];
  private dateQueryParams: Pick<ContrattiFilterParams, "dataInizio" | "dataFine"> = {
    dataInizio: undefined,
    dataFine: undefined,
  };
  private ospiteQueryParam: number | null = null;
  private hasQuietanzianteQueryParam: string | null = null;
  private tableLoading = false;

  private contrattoDaChiudere: Tuple | null = null;
  private contrattoChiuso: Date | null = null;
  private contrattoChiusoValid = false;
  private showChiudiDialog = false;

  /* GETTERS AND SETTERS */

  get canAdd(): boolean {
    return [RuoloUtente.ROOT, RuoloUtente.ADMIN, RuoloUtente.SPORTELLO].includes(this.$store.getters.role);
  }

  get canEdit(): boolean {
    return [RuoloUtente.ROOT, RuoloUtente.ADMIN, RuoloUtente.SPORTELLO].includes(this.$store.getters.role);
  }

  get columns(): Column<Tuple>[] {
    return [
      {
        text: "ID",
        value: "id",
        groupable: false,
        editable: false,
      },
      {
        text: "Data inizio",
        value: "dataInizio",
        groupable: false,
        sort: (x: Date, y: Date) => +x - +y,

        editable: false,
        itemTextHandler: (value) => value.toLocaleDateString(),
      },
      {
        text: "Data fine",
        value: "dataFine",
        groupable: false,
        sort: (x: Date, y: Date) => +x - +y,

        editable: false,
        itemTextHandler: (value) => value.toLocaleDateString(),
      },
      {
        text: "C. anticipata",
        value: "dataChiusuraAnticipata",
        groupable: false,
        sort: (x: Date, y: Date) => +x - +y,

        editable: false,
        itemTextHandler: (value) => (value ? value.toLocaleDateString() : "NO"),
      },
      {
        text: "Nome",
        value: "nome",
        groupable: false,
        editable: false,
      },
      {
        text: "Cognome",
        value: "cognome",
        groupable: false,
        editable: false,
      },
      {
        text: "Cod.Fiscale",
        value: "codiceFiscale",
        groupable: false,
        editable: false,
      },
      {
        text: "Tipo",
        value: "tipoContratto",
        groupable: false,
        editable: false,
      },
      {
        text: "Fabbricato",
        value: "codiceFabbricato",
        groupable: false,
        editable: false,
      },
      {
        text: "N. stanza",
        value: "numeroStanza",
        groupable: false,
        editable: false,
      },
      {
        text: "Q",
        value: "idQuietanziante",
        groupable: false,
        editable: false,
        itemIcon: true,
        itemIconHandler: (value) => (value !== 1 ? "mdi-check" : ""),
        itemTextHandler: () => "",
        itemIconColour: () => "success",
      },
    ];
  }

  get exportedHeaders() {
    return this.columns ? this.getExportHeadersFromCols(this.columns) : {};
  }

  get actions(): Actions<Tuple> {
    return {
      onView: (item) => `../contratti/${item.id}`,
      others: [
        {
          icon: "mdi-download",
          color: "indigo",
          title: "Download contratto",
          action: (item) => this.downloadContratto(item, ContrattiPDFTypes.CONTRATTO),
        },
        {
          icon: "mdi-download",
          color: "purple",
          title: "Download Chiusura anticipata",
          action: (item) => this.downloadContratto(item, ContrattiPDFTypes.CHIUSURA_ANTICIPATA),
          showAction: (item) => item.reference.fileChiusuraAnticipata !== null,
        },
        {
          icon: "mdi-close-circle",
          color: "orange",
          title: "Chiudi contratto",
          action: (item) => this.openChiudiContratto(item),
          showAction: (item) => item.dataChiusuraAnticipata === null && this.canEdit,
        },
        {
          icon: "mdi-delete",
          color: "red",
          title: "Elimina contratto",
          action: (item) => this.askDelete(item),
          showAction: () => this.isRoot,
        },
      ],
    };
  }

  get queryParams(): ContrattiFilterParams {
    return {
      ...this.dateQueryParams,
      idOspite: this.ospiteQueryParam ?? undefined,
      hasQuietanziante: this.hasQuietanzianteQueryParam === "SI" ? true : this.hasQuietanzianteQueryParam === "NO" ? false : undefined,
    };
  }

  /* METHODS */

  contrattoValueToTuple(contratto: ContrattiReturned): Tuple {
    return {
      id: contratto.id,
      dataInizio: contratto.dataInizio,
      dataFine: contratto.dataFine,
      nome: contratto.contrattiSuOspite?.[0].ospite?.persona?.nome ?? "",
      cognome: contratto.contrattiSuOspite?.[0].ospite?.persona?.cognome ?? "",
      codiceFiscale: contratto.contrattiSuOspite?.[0].ospite?.persona?.codiceFiscale ?? "",
      tipoContratto: contratto.tipoContratto?.sigla ?? "",
      codiceFabbricato: contratto.contrattiSuOspite?.[0].contrattiSuOspiteSuPostoLetto?.[0].postoLetto?.stanza?.fabbricato?.codice ?? "",
      unitaImmobiliare: contratto.contrattiSuOspite?.[0].contrattiSuOspiteSuPostoLetto?.[0].postoLetto?.stanza?.unitaImmobiliare ?? "",
      numeroStanza: contratto.contrattiSuOspite?.[0].contrattiSuOspiteSuPostoLetto?.[0].postoLetto?.stanza?.numeroStanza ?? "",
      postiLetto: contratto.contrattiSuOspite?.[0].contrattiSuOspiteSuPostoLetto
        ? contratto.contrattiSuOspite[0].contrattiSuOspiteSuPostoLetto.map((pl) => pl.postoLetto).join(", ")
        : "",
      dataFirma: contratto.dataFirmaContratto,
      dataChiusuraAnticipata: contratto.dataChiusuraAnticipata,
      reference: contratto,
      idQuietanziante: contratto.idQuietanziante,
    };
  }

  getIdFromValue(value: Tuple): number {
    return value.reference.id;
  }

  async deleteHandler(id: number, isMultiple: boolean): Promise<void> {
    await this.deleteContratto(id, isMultiple ? AlertType.ERRORS_QUEUE : AlertType.ERROR_ALERT);
  }

  async createHandler(value: ContrattiCreateBody): Promise<{ id: number; details: null; push: boolean }> {
    const id = await this.createContratto(value);
    return {
      id,
      details: null,
      push: false,
    };
  }

  async updateHandler(id: number, value: ContrattiReplaceBody, isTableEdit: boolean): Promise<void> {
    await this.updateContratto(id, value, isTableEdit ? AlertType.ERRORS_QUEUE : AlertType.ERROR_ALERT);
  }

  updateBodyFromValue(value: Tuple): ContrattiReplaceBody {
    return {
      dataInizio: value.reference.dataInizio,
      dataFine: value.reference.dataFine,
      checkout: !!value.reference.checkout,
      cauzione: !!value.reference.cauzione,
      tipoRata: value.reference.tipoRata,
      idTariffa: value.reference.idTariffa,
      idTipoContratto: value.reference.idTipoContratto,
      idQuietanziante: value.reference.idQuietanziante,
      ospiti: value.reference.contrattiSuOspite
        ? value.reference.contrattiSuOspite.map((cso) => ({
            idOspite: cso.idOspite,
            postiLetto: cso.contrattiSuOspiteSuPostoLetto ? cso.contrattiSuOspiteSuPostoLetto.map((pl) => pl.idPostoLetto) : [],
          }))
        : [],
      note: value.reference.note,
    };
  }
  async tupleValueFromCreateBody(id: number): Promise<Tuple> {
    const contratto = await this.getContratto(id, {
      tipoContratto: true,
      contrattiSuOspite: {
        ospite: { persona: true },
        contrattiSuOspiteSuPostoLetto: {
          postoLetto: true,
        },
      },
    });
    return this.contrattoValueToTuple(contratto);
  }
  async tupleValueFromUpdateBody(id: number): Promise<Tuple> {
    const contratto = await this.getContratto(id, {
      tipoContratto: true,
      contrattiSuOspite: {
        ospite: { persona: true },
        contrattiSuOspiteSuPostoLetto: {
          postoLetto: true,
        },
      },
    });
    return this.contrattoValueToTuple(contratto);
  }

  openChiudiContratto(tuple: Tuple): void {
    this.contrattoDaChiudere = tuple;
    this.showChiudiDialog = true;
    this.contrattoChiuso = null;
    this.contrattoChiusoValid = false;
  }
  chiudiDialogCancel(): void {
    this.showChiudiDialog = false;
    this.contrattoDaChiudere = null;
    this.contrattoChiuso = null;
  }
  chiudiDialogConfirm(): void {
    if (!this.contrattoChiusoValid) {
      this.chiudiDialogCancel();
      return;
    }

    const data = this.contrattoChiuso as Date;
    const idContratto = this.contrattoDaChiudere?.id as number;

    this.$store.dispatch(ActionTypes.SHOW_CONFIRM_DIALOG, {
      text: `Confermi la chiusura anticipata del contratto in data ${data.toLocaleDateString()}?`,
      callback: async (answer: boolean) => {
        if (answer) {
          try {
            await this.closeContrattoInAnticipo(idContratto, { data });
            const index = this.contratti.findIndex((contratto) => contratto.id === idContratto);
            if (index !== -1) {
              this.contratti[index].dataChiusuraAnticipata = data;
            }
          } finally {
            this.chiudiDialogCancel();
          }
        }
      },
    });
  }

  async downloadContratto(tuple: Tuple, type: ContrattiPDFTypes): Promise<void> {
    try {
      const filename = type === ContrattiPDFTypes.CONTRATTO ? `${tuple.id}.pdf` : `${tuple.id}_chiusura.pdf`;
      const path = this.$stored.getPath(`contratti/${filename}`);
      const response = await axios.get(path, { responseType: "blob" });
      const blob: Blob = response.data;

      const downloadFilename = type === ContrattiPDFTypes.CONTRATTO ? `Contratto_firmato_${tuple.id}.pdf` : `Chiusura_anticipata_firmato_${tuple.id}.pdf`;
      downloadBlob(blob, downloadFilename);
    } catch (error) {
      this.$store.dispatch(ActionTypes.ALERT, { message: `File non trovato`, alertType: AlertType.ERRORS_QUEUE });
    }
  }

  async fetchContratti(): Promise<void> {
    try {
      this.tableLoading = true;
      this.contratti = await this.getContrattiAttivi({
        tipoContratto: true,
        contrattiSuOspite: {
          ospite: { persona: true },
          contrattiSuOspiteSuPostoLetto: {
            postoLetto: true,
          },
        },
        ...this.queryParams,
      });
    } finally {
      this.tableLoading = false;
    }
  }

  /* WATCH */

  @Watch("contratti", { deep: true })
  watchContratti() {
    this.values = this.contratti.map((c) => this.contrattoValueToTuple(c));
  }

  @Watch("queryParams", { deep: true })
  async watchQueryParams() {
    await this.fetchContratti();
  }

  /* LIFE CYCLE */

  async mounted() {
    await this.fetchContratti();
  }
}
